/**
 * Platform login images (bg + logo) loaded via require.context so they are
 * included in the build. Add images under assets/images/<platform>/:
 * - bg.png (or .jpg/.svg)
 * - login_logo_new.png (or .jpg/.svg)
 */

type PlatformImages = { bg: string; logo: string };

// Include all images under assets/images/*/ so the bundler includes them (Webpack require.context)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const req = (require as any).context("../assets/images", true, new RegExp("\\.(png|jpe?g|svg)$"));
const keys = req.keys();

const platformMap: Record<string, PlatformImages> = {};

keys.forEach((key: string) => {
	const normalized = key.replace(/^\.\//, "");
	const parts = normalized.split("/");
	if (parts.length < 2) return;
	const platform = parts[0];
	const filename = parts[parts.length - 1]?.toLowerCase() ?? "";
	if (!platformMap[platform]) {
		platformMap[platform] = { bg: "", logo: "" };
	}
	const url = req(key) as string;
	if (filename === "bg.png" || filename === "bg.jpg" || filename === "bg.jpeg" || filename === "bg.svg") {
		platformMap[platform].bg = url;
	} else if (
		filename === "login_logo_new.png" ||
		filename === "login_logo_new.jpg" ||
		filename === "login_logo_new.jpeg" ||
		filename === "login_logo_new.svg"
	) {
		platformMap[platform].logo = url;
	}
});

const DEFAULT_PLATFORM = "lumio";

export function getPlatformImages(platformStyle: string): PlatformImages {
	const normalized = (platformStyle || "").trim();
	const entry = normalized && platformMap[normalized] ? platformMap[normalized] : platformMap[DEFAULT_PLATFORM];
	// Fallback if platform has missing assets
	return {
		bg: entry?.bg ?? platformMap[DEFAULT_PLATFORM]?.bg ?? "",
		logo: entry?.logo ?? platformMap[DEFAULT_PLATFORM]?.logo ?? "",
	};
}
